import React, { useEffect, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { Button, Col, Dropdown, Icon, Menu, message, Modal, Row, Select, Table, Tag, Typography } from "antd";

import Loader from "components/Loader/Loader";
import FloatingActionButton from "components/FloatingActionButton/FloatingActionButton";

import emptyImage from "../../media/empty-survey-list.svg";

import { archiveSurveyApi, deleteSurveyApi, fetchSurveyArchiveCountApi, fetchSurveyListApi, publishSurveyApi } from "utils/apiService";
import moment from "moment";

const { Text } = Typography;
const { Option } = Select;

const SurveyTable = (props) => {
	const { data } = props;

	const [deleteModal, setDeleteModal] = useState(false);
	const deleteForm = useRef("");

	// const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	// const rowSelection = {
	// 	selectedRowKeys,
	// 	onChange: (selectedRowKeys) => {
	// 		props.handleRowSelection(selectedRowKeys);
	// 		setSelectedRowKeys(selectedRowKeys);
	// 	},
	// };

	const columns = [
		{
			title: "Survey Name",
			dataIndex: "title",
			key: "surveyName",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818", whiteSpace: "nowrap" }}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
		{
			title: "Questions",
			dataIndex: "questions",
			key: "questions",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818", whiteSpace: "nowrap" }}>
						{data ? data : "0"}
					</Text>
				);
			},
		},
		{
			title: "Responses",
			dataIndex: "responses",
			key: "responses",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818", whiteSpace: "nowrap" }}>
						{data ? data : "0"}
					</Text>
				);
			},
		},
		{
			title: "Status",
			dataIndex: "is_published",
			key: "publish",
			render: (status) => (status ? <Tag color="green">Running</Tag> : <Tag color="gray">Stopped</Tag>),
		},
		{
			title: "Created On",
			dataIndex: "date_created",
			key: "createdOn",
			render: (date) => <div style={{ whiteSpace: "nowrap" }}>{date}</div>,
		},
		{
			title: "",
			dataIndex: "uuid",
			key: "uuid",
			render: (uuid, row) => {
				return (
					<div style={{ width: "16px" }}>
						<Dropdown
							placement={"bottomLeft"}
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{ marginLeft: "0" }}
							overlay={
								<Menu>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											props.history.push(`${props.location?.pathname}/${uuid}/edit`);
										}}>
										<Text style={{ color: "#181818" }}>Edit Survey</Text>
									</Menu.Item>
									{!row.is_published && (
										<Menu.Item
											onClick={(e) => {
												e.domEvent.stopPropagation();
												archiveSurveyApi({
													requestData: {
														uuid: uuid,
														status: props.noAction ? "unarchive" : "archive",
													},
													res200Callback: () => {
														props.updatePage();
													},
												});
											}}>
											<Text style={{ color: "#181818" }}>{props.noAction ? "Unarchive" : "Archive"}</Text>
										</Menu.Item>
									)}
									{!row.is_published && (
										<Menu.Item
											onClick={(e) => {
												e.domEvent.stopPropagation();
												deleteForm.current = uuid;
												setDeleteModal(true);
											}}>
											<Text style={{ color: "#F5222D" }}>Delete</Text>
										</Menu.Item>
									)}
								</Menu>
							}>
							<Icon
								type="more"
								onClick={(e) => {
									e.stopPropagation();
								}}
								style={{ fontSize: "16px", color: "#747474", marginLeft: "52px" }}
							/>
						</Dropdown>
					</div>
				);
			},
		},
	];

	return (
		<>
			<Table
				// rowSelection={props.noAction ? null : rowSelection}
				columns={(function () {
					// if (props.noAction) {
					// 	return columns.filter((item) => item.key != "x");
					// }
					return columns;
				})()}
				dataSource={data.surveyForms}
				pagination={{ showQuickJumper: true, pageSize: data.pageSize }}
				style={{ overflow: "none" }}
				// onChange={(pagination) => {
				// 	props.updatePage(pagination.current);
				// }}
				onRow={(obj) => ({
					onClick: () => {
						props.history.push(`${props.location?.pathname}/${obj?.uuid}`);
					},
				})}
				loading={props.loading}
			/>
			<Modal centered visible={deleteModal} destroyOnClose maskClosable={false} onCancel={() => setDeleteModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="delete"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Delete item
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<Col span={24}>
							<Text>Are you sure you want to delete this Survey Form?</Text>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setDeleteModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#C91713",
									color: "#FFFFFF",
								}}
								onClick={() => {
									deleteSurveyApi({
										requestData: {
											uuid: deleteForm.current,
										},
										res200Callback: () => {
											setDeleteModal(false);
											props.updatePage();
										},
									});
								}}>
								Delete
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>
		</>
	);
	// ) : (
	// 	<>
	// 		<Empty activeKey={props.noAction} />
	// 	</>
	// );
};

const SurveyFormList = (props) => {
	let { path, url } = useRouteMatch();
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(true);
	const [stagePublish, setStagePublish] = useState("");
	const [activeTab, setActiveTab] = useState(path === "/app-feedback" ? "all" : "archived");

	const [surveyFormList, setSurveyFormList] = useState({
		surveyForms: [],
		// pageNum: 1,
		pageSize: 10,
		// totalPages: 1,
	});
	const [surveyFormCounts, setSurveyFormCounts] = useState({
		all: 0,
		archived: 0,
	});

	const loadTable = () => {
		setTableLoading(true);
		fetchSurveyListApi({
			requestData: {
				is_archived: activeTab === "archived",
			},
			resCallback: () => {
				loading && setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				setSurveyFormList({ ...surveyFormList, surveyForms: res.data.survey_list });
			},
		});
		fetchSurveyArchiveCountApi({
			requestData: {},
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				setSurveyFormCounts({ archived: res.data.archived, all: res.data.unarchived });
			},
		});
	};

	const publishSurvey = () => {
		stagePublish &&
			publishSurveyApi({
				requestData: {
					uuid: stagePublish,
					status: "publish",
				},
				resCallback: () => {},
				res200Callback: () => {
					message.success("Survey Published Successfully.");
					loadTable();
				},
				resErrorCallback: () => {
					message.error("Failed publishing the survey!");
				},
			});
	};

	useEffect(() => {
		loadTable();
	}, [activeTab]);
	
	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : surveyFormCounts.all + surveyFormCounts.archived === 0 ? (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "#FAFAFA",
					marginTop: 100,
				}}>
				<img src={emptyImage} alt="Illustration for empty survey list" />
				<Text style={{ fontSize: "20px", color: "#181818", fontWeight: "bold", marginTop: "16px" }}>You have not created Survey Form yet.</Text>
				<Text style={{ color: "#747474", marginTop: "8px", textAlign: "center" }}>Survey Form will appear hear!</Text>
				<Button
					size={"large"}
					onClick={() => {
						props.history.push(`${props.location.pathname}/create-form`);
					}}
					style={{
						marginTop: "24px",
						backgroundColor: "#fec708",
						color: "#FFFFFF",
						border: "none",
						borderRadius: "5px",
					}}>
					<Icon type="plus" />
					Create Survey Form
				</Button>
			</div>
		</>
	) : (
		<>
			<Row type="flex" align="middle" justify="space-between">
				<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "39px" }}>
					Survey
				</Text>
				<Row type="flex" align="middle">
					<Select
						showSearch
						allowClear
						style={{
							display: "flex",
							alignItems: "center",
							// padding: "8px 8px",
							justifyContent: "space-between",
							width: 200,
							border: "1px solid #D9D9D9",
							borderRadius: "5px",
							height: "40px",
							textOverflow: "ellipsisis",
						}}
						placeholder="Select a Survey"
						optionFilterProp="children"
						onChange={(value) => setStagePublish(value)}
						filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
						{surveyFormList.surveyForms?.map((survey) => (
							<Option key={survey.uuid} value={survey.uuid}>
								{survey.title}
							</Option>
						))}
					</Select>
					<Button
						onClick={publishSurvey}
						disabled={!stagePublish}
						style={{
							display: "flex",
							alignItems: "center",
							padding: "8px 16px",
							color: "#FFFFFF",
							fontSize: "16px",
							lineHeight: "24px",
							background: "#fec708",
							borderRadius: "5px",
							height: "100%",
							margin: "0 0 0 12px",
						}}>
						<Icon
							type="form"
							style={{
								height: "16px",
							}}
						/>
						Publish Survey
					</Button>
				</Row>
			</Row>
			<Menu selectedKeys={activeTab} onSelect={(e) => setActiveTab(e.key)} mode="horizontal" style={{ backgroundColor: "transparent" }}>
				<Menu.Item key="all">
					{/* <Link to={`${url}`}> */}
					All {`(${surveyFormCounts.all})`}
					{/* </Link> */}
				</Menu.Item>
				<Menu.Item key="archived">
					{/* <Link to={`${url}/archived`}> */}
					Archived {`(${surveyFormCounts.archived})`}
					{/* </Link> */}
				</Menu.Item>
			</Menu>
			<SurveyTable
				{...props}
				loading={tableLoading}
				data={surveyFormList}
				updatePage={() => {
					// setSurveyFormList({ ...surveyFormList, pageNum: currentPage });
					loadTable();
				}}
				noAction={activeTab === "archived"}
			/>
			<FloatingActionButton
				iconType="plus"
				tooltipTitle={<Text style={{ color: "#fec708" }}>Create a new form</Text>}
				handleClick={() => {
					props.history.push(`${url}/create-form`);
				}}
			/>
		</>
	);
};

export default SurveyFormList;
